import { render, staticRenderFns } from "./ExternalNett.vue?vue&type=template&id=68994789&"
import script from "./ExternalNett.vue?vue&type=script&lang=js&"
export * from "./ExternalNett.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports